var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
export function hasOwnProperty(obj, key) {
  return obj && prototypeHasOwnProperty.call(obj, key);
}